/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.PackageTypes {
  angular.module("meevo.plugins.packageTypes", []);
}